<template>
  <div>
    <ModalHolder :title="''" m-top="120" width="380px" m-height="35vh" :is-show="isShow">
      <template slot="mheader">
        <div class="modal-header">
          <!-- <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
            <Icon size="20" type="close-circled"></Icon>
          </span>-->
          <img class="category-icon" :src="icon(category)" alt srcset />
          <strong
            style="text-transform: capitalize;"
            :style="{color: color(category)}"
          >{{ category }}</strong>
        </div>
      </template>
      <template slot="mcontent" style="display: flex;">
        <div class="breakdown-content">
          <div class="loader" v-if="getLogLoader">
            <Spin />
          </div>
          <div class="breakdown-list" v-else-if="!getLogLoader && getLog(category).data && getLog(category).data.length > 0">
            <div class="breakdown-item" v-for="(event, i) in getLog(category).data" :key="i">
              <div class="breakdown-item-content">
                <div v-if="event.action.action == 'bookmark'">
                  <div class="card-title">
                    Bookmarked an item
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/feed/' + event.element.id"
                    v-if="event.element"
                  >{{ event.element.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'join_group'">
                  <div class="card-title">
                    Joined a group
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/resources/' + event.module.id"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'like'">
                  <div class="card-title">
                    Liked a post
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/resources/' + event.module.id"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'comment'">
                  <div class="card-title">
                    Commented on a post
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/feed/' + event.element.id"
                    v-if="event.element"
                  >{{ event.element.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'view_post'">
                  <div class="card-title">
                    Viewed a post
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/feed/' + event.element.id"
                    v-if="event.element"
                  >{{ event.element.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'open_course'">
                  <div class="card-title">
                    Opened a course
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/module/' + event.module.id + '?floating=true'"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'view_image'">
                  <div class="card-title">
                    Viewed an image
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/feed/' + event.element.id"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'watch_video'">
                  <div class="card-title">
                    Watched a video from
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/feed/' + event.element.id"
                    v-if="event.element && event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'complete_profile'">
                  <div class="card-title">
                    Complete Profile
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/profile/' + userInfo.id + '?floating=true'"
                  >Go to profile</router-link>
                </div>
                <div v-else-if="event.action.action == 'finish_course'">
                  <div class="card-title">
                    Finished a course
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/module/' + event.module.id + '?floating=true'"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'module_visit'">
                  <div class="card-title">
                    Visited a course
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/module/' + event.module.id + '?floating=true'"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
                <div v-else-if="event.action.action == 'view_contact'">
                  <div class="card-title">
                    Viewed contact detail of a course
                    <timeago :since="event.created_at" class="action-time" />
                  </div>
                  <router-link
                    @click.native="dismissModal"
                    :to="'/module/' + event.module.id + '?floating=true'"
                    v-if="event.module"
                  >{{ event.module.title }}</router-link>
                  <span v-else>...</span>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 100%;display: flex; justify-content: center; align-items: center;" v-else>
            <span>Points not available</span>
          </div>
          <div class="load-more" v-if="!getLogLoader && getLog(category).next_link">
            <Button
              size="small" type="text"
              @click="loadMore"
              :loading="getNextLogLoader"
              :disabled="getNextLogLoader"
            ><a><small>Load more</small></a></Button>
          </div>
        </div>
      </template>
      <template slot="mfooter">
        <div  style="display: flex; justify-content: flex-end">
          <Button size="small" ghost type="error" style="float: left;" @click="dismissModal()">Close</Button>
        </div>
      </template>
    </ModalHolder>
  </div>
</template>

<script>
import copeImg from "@/assets/svg/cope.svg";
import thriveImg from "@/assets/svg/thrive.svg";
import nourishImg from "@/assets/svg/nourish.svg";
import healImg from "@/assets/svg/heal.svg";
import { mapGetters } from "vuex";
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  name: "PointsBreakdownModal",
  components: {
    ModalHolder
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("points", [
      "showPointsModal",
      "getLog",
      "getLogLoader",
      "getNextLogLoader",
      "getModalCategory"
    ]),
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    isShow: {
      get() {
        return this.showPointsModal;
      },
      set(v) {
        this.$store.commit("points/setShowPointsModal", v);
      }
    },
    category() {
      return this.getModalCategory;
    }
  },
  methods: {
    loadMore() {
      this.$store.dispatch("points/getCurrentUserCategoryNextLog", {
        journalId: this.userInfo.journal_id,
        category: this.category,
        page: this.getLog(this.category).page + 1,
        brandId: this.brandInfo.id
      });
    },
    dismissModal() {
      this.isShow = false;
    },
    icon(v) {
      switch (v) {
        case "heal":
          return healImg;
          break;
        case "nourish":
          return nourishImg;
          break;
        case "thrive":
          return thriveImg;
          break;
        case "cope":
          return copeImg;
          break;
        default:
          return copeImg;
      }
    },
    color(v) {
      switch (v) {
        case "heal":
          return "#4E1C9B";
          break;
        case "nourish":
          return "#83CA27";
          break;
        case "thrive":
          return "#F19B2F";
          break;
        case "cope":
          return "#1E89A7";
          break;
        default:
          return "red";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.breakdown-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .loader {
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    display: flex;
  }
  .breakdown-list {
    width: 100%;
    .breakdown-item {
      padding: 8px 0 0;
      font-weight: 400;
      display: flex;
      align-items: center;
      border-bottom: 1.3px solid #ddd;
      .breakdown-item-content {
        width: 100%;
        justify-content: space-between;
        > div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          > a {
            line-height:10px;
            font-size: 14px;
          }
        }
      }
    }
    .card-title {
      font-size: 13px;
      display: flex;
      line-height:12px;
      align-items: center;
      justify-content: space-between;
      .action-time {
        font-size: 12px;
        color: #aeaeae;
      }
    }
  }
  .load-more {
    display: flex;
    width: 100%;
    justify-content: center;
    margin: 8px;
  }
}
.modal-header {
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .category-icon {
    width: 20px;
    height: 100%;
    margin-right: 6px;
  }
}
</style>